import { apiRequest } from '../lib/apiClient';

export function getPromoPage({ alias, subdomain, promoSubdomain }) {
  const normalizedAlias = String(alias || '').trim();
  const endpoint = normalizedAlias
    ? `/api/public/promos/${encodeURIComponent(normalizedAlias)}`
    : '/api/public/promos';

  return apiRequest(endpoint, {
    method: 'GET',
    query: {
      alias: normalizedAlias || undefined,
      subdomain,
      promo_subdomain: promoSubdomain,
    },
  });
}

export function submitPromoEnquiry({ alias, payload }) {
  const normalizedAlias = String(alias || '').trim();
  const endpoint = normalizedAlias
    ? `/api/public/promos/${encodeURIComponent(normalizedAlias)}/enquiries`
    : '/api/public/promos/enquiries';

  return apiRequest(endpoint, {
    method: 'POST',
    body: {
      ...payload,
      alias: normalizedAlias || payload?.alias || undefined,
    },
  });
}
